<template>
<ul ref="options" class="odr-options">
    <template v-for="(item, index) in values">
        <button v-if="item.type !== 'markup'"
                :key="item.id"
                :ref="`item${index}`"
                type="button"
                tabindex="-1"
                data-options=""
                :data-qa="dataQa ? $setQa(`${dataQa}.${item.id}`, { focused: focusedId === index }) : null"
                class="odr-options__item"
                :class="{
                    'odr-options__item_choosed': value === item.id,
                    'odr-options__item_focused': focusedId === index
                }"
                @click="event => {handleClick(item.id); event.preventDefault()}"
                @keydown.enter="event => {handleClick(item.id); event.preventDefault()}">
            <tpl :content="item.description || item.title || item.match"/>
        </button>
        <div v-else :key="(item.description || item.title || item.match) + item.id">
            <tpl :content="item.description || item.title || item.match"/>
        </div>
    </template>
</ul>
</template>

<script>
import '@/scss/blocks/options.scss';
import { hideDropdown } from '@/utils/dropdown';
import { bus } from '@/utils/sticky';

export default {
    props: {
        dataQa: {},
        value: {},
        values: {},
        focusId: {},
        scrollGap: {
            default: 30,
        },
    },
    data () {
        return {
            focusedId: this.focusId,
        };
    },
    watch: {
        focusId () {
            this.focusedId = this.focusId;
        },
        focusedId () {
            if (!this.$refs[`item${this.focusedId}`]) {
                return;
            }
            let element = this.$refs[`item${this.focusedId}`][0];
            if (element && this.$refs.options) {
                let optionsRect = this.$refs.options.getBoundingClientRect();
                let elementRect = element.getBoundingClientRect();

                this.$emit('selectedBoundings', {
                    top: elementRect.top - optionsRect.top - this.scrollGap,
                    bottom: elementRect.bottom - optionsRect.top + this.scrollGap,
                });
            }
        },
        values () {
            bus.$emit('possible-resize');
        },
    },
    methods: {
        handleClick (id) {
            this.$emit('input', id);
            this.$emit('finished');
            this.hideDropdown(this.dataQa);
        },
        hideDropdown,
    },
    components: {
        tpl: require('@/vue/markup/tpl.vue').default,
    },
};
</script>
